<template>
    <div style="display:flex;">
        <RightWing :index="1" />
        <div style="width:100%; background-color:#eFeFeF">
            <h1 style="font-size:25px; margin:30px; font-weight:700;">
                사실일까? 거짓일까?
            </h1>

            <h1 style="padding:20px 0px; border-radius:5px; background-color:white;
                margin: 30px 30px; font-size:35px; font-weight:700;">
                "{{this.articleTitle}}"
            </h1>

            <div style="margin:10px 30px; display:flex; justify-content: space-between;">

                <div v-for="(clue, index) in clueSlot" :key="clue.idx"
                    @click="selectSlot(index)"
                    v-bind:class="{correct:clue.result=='적합', incorrect:clue.result=='부적합'}"
                    style="width:300px; height:200px; font-size:30px;
                        border-radius:30px; box-shadow:2px 2px 2px grey;
                        border:#444444 solid 2px; padding:30px 0px; text-align:center;">
                    <div v-html="clue.title" style="padding:20px; color:#444444;"></div>
                </div>

            </div>

            <div style="text-align:center; font-size:20px;">대충 몇 점 받을 거라는 얘기... 더 많이 찾으면 더 많이 받을 거라는 얘기...</div>
            <!-- <router-link to="/selectTrueOrNot" v-if="complete" class="bottom_btn">판별하러 가기</router-link> -->
            <div style="margin:30px; padding:20px; text-align:center;">
                <span @click="toClueList" style="font-size:30px; padding:10px 20px; border:2px solid black; margin:20px; border-radius:10px;">근거 선택 하러 가기</span>
                <span v-if="complete" @click="next" style="font-size:30px; padding:10px 20px; border:2px solid black; margin:20px; border-radius:10px;">판별 하러 가기</span>
            </div>

        </div>
    </div>
</template>

<script>
import RightWing from '../components/RightWingView.vue'

export default {
    name: 'ArticleDetailView3',

    components: {
        'RightWing': RightWing
    },

    data() {
        return {
            selectedArticleData: null,
            articleTitle: null,
            clueSlot: null
        }
    },

    computed: {
        complete: function() {
            let count = 0
            if(this.clueSlot == null) {
                return false
            }
            for(const clue of this.clueSlot) {
                if(clue.result == '적합') {
                    count++
                }
            }
            if(count > 0) {
                return true
            }
            else {
                return false
            }
        }
    },

    mounted() {
        let currentGame = this.$getCurrentGame()
        this.selectedSectionData = this.$gameData.sections[currentGame.selectedSection].articles[currentGame.selectedArticle]
        this.articleTitle = this.selectedSectionData.title

        let currentArticleIndex = -1
        for(let i = 0; i < currentGame.articles.length; i++) {
            let article = currentGame.articles[i]
            if(article.title == this.articleTitle) {
                currentArticleIndex = i
                break
            }
        }

        this.clueSlot = currentGame.articles[currentArticleIndex].cluesChosen

        // let clues = window.localStorage.getItem('clueSlot')
        // if(clues != null) {
        //     this.clueSlot = JSON.parse(clues)
        // }
        // else {
        //     this.clueSlot = [
        //         {'title': '여기를 터치해서<br>적절한 근거를<br>선택하세요', 'idx': 0},
        //         {'title': '여기를 터치해서<br>적절한 근거를<br>선택하세요', 'idx': 1},
        //         {'title': '여기를 터치해서<br>적절한 근거를<br>선택하세요', 'idx': 2}]
        //         window.localStorage.setItem('clueSlot', JSON.stringify(this.clueSlot))
        // }
    },

    methods: {
        selectSlot: function(index) {
            // this.$router.push('/clueList3')
            // window.localStorage.setItem('selectedClueSlot', index)
            console.log('여기 동작 없애야 할 듯' + index)
        },
        next: function() {
            this.$router.push('/selectTrueOrNot')
        },
        toClueList: function() {
            this.$router.push('/clueList3')
        }
    },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.correct{
    background-color:#81C195;
}
.incorrect {
    background-color:#DF5D5B;
}
.not_selected {
    background-color:#dddddd;
}
</style>
